import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@this/src/components/shared/ui/data_displays/table';
import type BizEkinetReservation from '@this/src/domain/arrangement/biz_ekinet_reservation_total';
import AirAutoBizEkinetReservationTotalTableRow from './total_result_table_row';

interface Props {
  bizEkinetReservationTotals: BizEkinetReservation[];
  fetchTodos: () => void;
}

const AirAutoBizEkinetReservationTotal: React.FC<Props> = ({ bizEkinetReservationTotals, fetchTodos }) => {
  return (
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell>予約日</TableCell>
          <TableCell>予約対象アイテム件数</TableCell>
          <TableCell>予約完了件数</TableCell>
          <TableCell>予約完了合計金額</TableCell>
          <TableCell>総数確認日</TableCell>
          <TableCell>総数確認者</TableCell>
          <TableCell>確認</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {bizEkinetReservationTotals.map(bizEkinetReservationTotal => (
          <AirAutoBizEkinetReservationTotalTableRow
            key={bizEkinetReservationTotal.reservationDate.format('YYYY-MM-DD')}
            bizEkinetReservationTotal={bizEkinetReservationTotal}
            onApprove={() => fetchTodos()}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default AirAutoBizEkinetReservationTotal;
